<template>
  <div
    v-if="!cookiesConsent"
    class="fixed bottom-[10vh] z-[50] flex flex-wrap items-center justify-between w-[95%] px-5 py-4 mx-auto bg-white rounded-xl lg:rounded-full max-w-4xl lg:px-8 xl:w-[65%] shadow-xl left-0 right-0 "
  >
    <p>
      This website uses cookies to improve your experience. <NuxtLink
        href="/privacy-policy"
        class="text-primary"
      >View Privacy Policy</NuxtLink>
    </p>
    <div class="flex flex-wrap gap-3 py-2">
      <!-- <button
          class="inline-flex items-center justify-center px-6 py-2 tracking-wide text-gray-400 uppercase duration-200 rounded-full lg:px-8 shadow-base hover:shadow-lg hover:-translate-y-1 will-change-transform group"
          @click="declineCookies">Decline</button> -->
      <UButton
        size="xl"
        class="font-display uppercase text-xl lg:text-2xl font-black"
        trailing
        @click="acceptCookies"
      >
        Accept
        <Icon
          name="gbf:arrow-right"
          class="text-yellow h-8 w-8 animate-side-ping"
        />
      </UButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const cookiesConsent = useCookie<'accepted' | 'declined' | undefined>('consent', undefined)

function acceptCookies() {
  cookiesConsent.value = 'accepted'
}
function declineCookies() {
  cookiesConsent.value = 'declined'
}

const agreedToCookiesScriptConsent = useScriptTriggerConsent()

watch(cookiesConsent, (newVal) => {
  if (newVal === 'accepted') {
    agreedToCookiesScriptConsent.accept()
  }
})

useScriptGoogleAnalytics({
  scriptOptions: {
    trigger: agreedToCookiesScriptConsent,
  },
})
</script>
